import axiosClient from './axiosClient';

export const cartService = {
    getCart: () => axiosClient.get('/customer/cart'),
    addToCart: (itemId, quantity = 1) => axiosClient.post('/customer/cart/add', { itemId, quantity }),
    updateQuantity: (itemId, quantity) => axiosClient.put('/customer/cart/update', { itemId, quantity }),
    removeFromCart: (itemId) => axiosClient.delete(`/customer/cart/remove/${itemId}`),
};